<template>
  <section class="workspace posire">
    <section class="workspace-module">
      <!-- 左侧入口列表 -->
<!--      <qx-card v-for="(cardItem, cardIndex) in list" :key="cardIndex" :title="cardItem.title">-->
<!--        <el-row v-for="(rowItem, rowIndex) in cardItem.children" :key="rowIndex">-->
<!--          <el-col v-for="(colItem, index) in rowItem" :key="index" :span="6">-->
<!--            <article-->
<!--              class="item posire"-->
<!--              :class="{-->
<!--              cur: Boolean(colItem.url)-->
<!--            }"-->
<!--              @click="toPage(colItem)"-->
<!--            >-->
<!--              <i-->
<!--                class="iconfont posiab"-->
<!--                :class="colItem.url ? colItem.color : 'blur'"-->
<!--                v-html="colItem.icon"-->
<!--              />-->
<!--              {{colItem.title}}-->
<!--            </article>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </qx-card>-->
    </section>
    <section>
      <!-- 左侧入口列表 end -->
      <!-- 右侧待我处理 -->
      <ApproveList />
      <!-- 右侧待我处理 end -->
    </section>
  </section>
</template>

<script>
import ApproveList from './approveList/approveList';
export default {
  components: {
    ApproveList,
  },
  data () {
    return {
      list: [
        { // 运营
          title: '运营',
          children: [
            [ // 第一行
              {
                title: '订单录入',
                icon: '&#xe7ed;',
                url: '/manage/operate/orderInput/logged',
                color: 'blue',
              },
              {
                title: '订单审核',
                icon: '&#xe7d0;',
                url: '/manage/operate/order/approve',
                color: 'orange',
              },
              {
                title: '订单处理',
                icon: '&#xe7cf;',
                url: '/manage/operate/order/deal',
                color: 'yellow',
              },
            ],
            [ // 第二行
              {
                title: '异常审核',
                icon: '&#xe7e2;',
                url: '/manage/operate/order/unusual',
                color: 'orange',
              },
              {
                title: '回单审核',
                icon: '&#xe7d9;',
                url: '/manage/operate/order/receipt',
                color: 'yellow',
              },
              {
                title: '时效审核',
                icon: '&#xe7de;',
                url: '/manage/operate/order/time',
                color: 'blue',
              },
              {
                title: '费用上报审核',
                icon: '&#xe7d2;',
                url: '/manage/cost/report/approve',
                color: 'orange',
              },
            ],
          ],
        }, // 运营 end
        { // 费用报销
          title: '费用报销',
          children: [
            [ // 第一行
              {
                title: '订单费用报销',
                icon: '&#xe7d1;',
                url: '/manage/cost/car/car/edit?id=&vehicleFeeType=2',
                color: 'yellow',
              },
              {
                title: '车辆费用报销',
                icon: '&#xe7c9;',
                url: '/manage/cost/car/car/edit?id=&vehicleFeeType=1',
                color: 'blue',
              },
              {
                title: '车辆费用报销审核',
                icon: '&#xe7ca;',
                url: '/manage/cost/car/feeReimbursement?state=0&waitDeal=true',
                color: 'orange',
                full: true,
              },
            ],
            [ // 第二行
              {
                title: '管理费用报销',
                icon: '&#xe7d4;',
                url: '/manage/cost/manage/feeEdit?id=&subjectsType=2',
                color: 'blue',
              },
              {
                title: '管理费用报销审核',
                icon: '&#xe7d5;',
                url: '/manage/cost/manage/feeReimbursement?state=0&waitDeal=true',
                color: 'orange',
                full: true,
              },
            ],
          ],
        }, // 费用报销 end
        { // 费用申请
          title: '费用申请',
          children: [
            [ // 第一行
              {
                title: '车辆费用申请',
                icon: '&#xe7cb;',
                url: '/manage/cost/car/car/edit?id=&vehicleFeeType=3',
                color: 'orange',
                full: true,
              },
              {
                title: '车辆费用申请审核',
                icon: '&#xe7cc;',
                url: '/manage/cost/car/feeApply?state=0&waitDeal=true',
                color: 'yellow',
                full: true,
              },
              {
                title: '管理费用申请',
                icon: '&#xe7d7;',
                url: '/manage/cost/manage/feeEdit?id=&subjectsType=1',
                color: 'blue',
                full: true,
              },
              {
                title: '管理费用审核',
                icon: '&#xe7d8;',
                url: '/manage/cost/manage/feeApply?state=0&waitDeal=true',
                color: 'orange',
                full: true,
              },
            ],
          ],
        }, // 费用申请 end
        { // 支付
          title: '支付',
          children: [
            [ // 第一行
              {
                title: '公司支付',
                icon: '&#xe7d3;',
                url: '/manage/getPay/writeOff/companyPay',
                color: 'yellow',
              },
              {
                title: '支付结果',
                icon: '&#xe7e8;',
                url: '/manage/getPay/pay/result',
                color: 'blue',
              },
              {
                title: '银行流水',
                icon: '&#xe7ea;',
                url: '/manage/getPay/pay/bankStatement',
                color: 'orange',
              },
            ],
          ],
        }, // 支付 end
        { // 借支
          title: '借支',
          children: [
            [ // 第一行
              {
                title: '司机出车借支',
                icon: '&#xe7df;',
                url: '/manage/cost/borrow/manage/edit?type=add&loanType=1',
                color: 'blue',
              },
              {
                title: '车辆维护借支',
                icon: '&#xe7ce;',
                url: '/manage/cost/borrow/manage/edit?type=add&loanType=2',
                color: 'orange',
              },
              {
                title: '员工借支',
                icon: '&#xe7e9;',
                url: '/manage/cost/borrow/manage/edit?type=add&loanType=3',
                color: 'yellow',
              },
              {
                title: '借支审核',
                icon: '&#xe7dc;',
                url: '/manage/cost/borrow/manage?state=0&waitDeal=true',
                color: 'blue',
                full: true,
              },
            ],
          ],
        }, // 借支 end
        { // 油卡
          title: '油卡',
          children: [
            [ // 第一行
              {
                title: '主卡管理',
                icon: '&#xe7e5;',
                url: '/manage/service/oil/masterCardManage',
                color: 'orange',
              },
              {
                title: '子卡管理',
                icon: '&#xe7e4;',
                url: '/manage/service/oil/daughterCardManage',
                color: 'yellow',
              },
              {
                title: '充值记录',
                icon: '&#xe7cd;',
                url: '/manage/service/oil/daughterCardManage',
                // url: '/manage/service/oil/oilcardRecharge',
                color: 'blue',
              },
              {
                title: '加油记录',
                icon: '&#xe7e1;',
                url: '/manage/service/oil/consume',
                color: 'orange',
              },
            ],
          ],
        }, // 油卡 end
        { // ETC
          title: 'ETC',
          children: [
            [ // 第一行
              {
                title: 'ETC卡管理',
                icon: '&#xe7ec;',
                url: '/manage/service/etc/manage',
                color: 'yellow',
              },
              {
                title: 'ETC充值记录',
                icon: '&#xe7e6;',
                url: '/manage/service/etc/rechargeRecord',
                color: 'blue',
              },
              {
                title: 'ETC消费记录',
                icon: '&#xe7eb;',
                url: '/manage/service/etc/consume',
                color: 'orange',
              },
            ],
          ],
        }, // ETC end
        { // 档案
          title: '档案',
          children: [
            [ // 第一行
              {
                title: '客户档案',
                icon: '&#xe7db;',
                url: '/manage/archives/customer/archives',
                color: 'blue',
              },
              {
                title: '客户线路',
                icon: '&#xe7dd;',
                url: '/manage/archives/customer/line',
                color: 'orange',
              },
              {
                title: '员工档案',
                icon: '&#xe7e7;',
                url: '/manage/system/jurisdiction/worker',
                color: 'yellow',
              },
              {
                title: '驾驶员档案',
                icon: '&#xe7da;',
                url: '/manage/archives/driver/archives',
                color: 'blue',
              },
            ],
            [ // 第二行
              {
                title: '外调车档案',
                icon: '&#xe7e0;',
                url: '/manage/car/archives/out',
                color: 'orange',
              },
              {
                title: '服务商档案',
                icon: '&#xe7d6;',
                url: '/manage/service/merchant/manage',
                color: 'yellow',
              },
              {
                title: '自有产品',
                icon: '&#xe7e3;',
                url: '/manage/service/site/self',
                color: 'blue',
              },
              {
                title: '自有车档案',
                icon: '&#xe7ef;',
                url: '/manage/car/archives/my',
                color: 'orange',
              },
            ],
            [ // 第三行
              {
                title: '挂车档案',
                icon: '&#xe7ee;',
                url: '/manage/car/trailer/archives',
                color: 'yellow',
              },
            ],
          ],
        }, // 档案 end
      ],
    };
  },
  methods: {
    toPage (item) {
      if (item.url) {
        this.jump({
          label: item.title,
          url: item.url,
          full: item.full,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.workspace {
  padding-right: 354px;
  height: 100%;
  // .approveList{
  //   top: 0;
  //   right: 0;
  // }
  .workspace-module {
    height: 100%;
    overflow: auto;

    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      border-radius: 10px;
      // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #999;
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #e0e0e0;
    }
  }
}
.item {
  height: 72px;
  line-height: 72px;
  width: 196px;
  margin: 0 auto 8px;
  padding-left: 76px;
  box-sizing: border-box;
  .iconfont {
    font-size: 56px;
    top: 0;
    left: 8px;
  }
  .orange {
    color: #ff875e;
  }
  .blue {
    color: #0088ff;
  }
  .yellow {
    color: #faad14;
  }
}
</style>
